import * as constants from '../constants';

const videos = (state = null, action) => {
  switch (action.type) {
    case constants.FETCH_VIDEOS_SUCCESS: {
      return [...action.payload];
    }
    case constants.API_OUT_OF_DATE:
    case constants.ACTIVATE_LANGUAGE: {
      return null;
    }
    default: {
      return state;
    }
  }
};

export default videos;



// WEBPACK FOOTER //
// ./src/store/reducers/videos.js